module.exports = __webpack_public_path__ + "static/media/ubicacion.3cd3f328.svg";